import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	width: 100%;
`;

export const Container = styled.div`
	display: grid;
	grid-template-columns: 0.2fr 1.5fr 2fr 0.4fr 0.2fr;
	align-items: center;
	gap: 12px;
	padding: 9px 18px;
	border-radius: 6px;
	width: 100%;
	padding: 16px 18px;

	label {
		cursor: auto;
	}
`;

export const ContainerProgressHeader = styled.div`
	display: grid;
	grid-template-columns: 1fr 68px;
	align-items: center;

	.graphic-icon {
		padding-left: 26px;
	}
`;

export const ContainerCentralize = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;

	label {
		cursor: auto;
	}
`;
